import React from 'react';
import styled from 'styled-components';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';
import { analytics } from '../../services/analytics';
import axios from 'axios';

interface PayPalButtonActiveStatusProps {
  amount: number;
  currency?: string;
  onSuccess: (details: any) => void;
  onError: (error: any) => void;
  onCancel: () => void;
  disabled?: boolean;
}

const PayPalContainer = styled.div`
  width: 100%;
  margin-top: ${props => props.theme.spacing.medium};
  min-height: 60px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #f9f9f9;
`;

const PayPalButtonActiveStatus: React.FC<PayPalButtonActiveStatusProps> = ({
  amount,
  currency = 'USD',
  onSuccess,
  onError,
  onCancel,
  disabled = false
}) => {

  const createOrder = async (data: any, actions: any) => {
    try {
      console.log('=== ACTIVESTATUSPRO CREATE ORDER ===');
      console.log('amount:', amount);
      
      // Track checkout initiation
      analytics.beginCheckout([{ name: 'ActiveStatusPro', price: amount }], amount);
      
      // Crear orden PayPal directamente - obtendremos customer data en onApprove
      return actions.order.create({
        purchase_units: [{
          amount: {
            value: amount.toString(),
            currency_code: currency
          },
          description: 'ActiveStatusPro - Herramienta de Productividad Remota'
        }],
        application_context: {
          return_url: `https://canvasoft.com/activestatuspro?success=true`,
          cancel_url: `https://canvasoft.com/activestatuspro?canceled=true`,
          landing_page: 'LOGIN',
          user_action: 'PAY_NOW',
          shipping_preference: 'NO_SHIPPING'
        }
      });
    } catch (error) {
      console.error('=== ERROR CREANDO ORDEN ACTIVESTATUSPRO ===');
      console.error('Error completo:', error);
      throw error;
    }
  };

  const onApprove = async (data: any, actions: any) => {
    try {
      console.log('=== ACTIVESTATUSPRO PAYPAL APPROVE ===');
      console.log('PayPal data:', data);
      
      const details = await actions.order.capture();
      console.log('PayPal details capturados:', details);
      
      // Extraer datos reales del pagador de PayPal
      const customerName = details.payer?.name?.given_name + ' ' + details.payer?.name?.surname || 'Cliente ActiveStatusPro';
      const customerEmail = details.payer?.email_address || '';
      
      console.log('Customer data from PayPal:');
      console.log('- Name:', customerName);
      console.log('- Email:', customerEmail);
      
      // 1. Crear compra en backend con datos REALES de PayPal
      const orderData = {
        customerName: customerName,
        customerEmail: customerEmail,
        montoTotal: amount.toString()
      };
      
      console.log('Creando compra con datos reales:', orderData);
      
      const response = await axios.post('https://dynappmos.com:8488/dynappmos/services/sendmail/activestatuspro/compra', orderData);
      console.log('response del backend ActiveStatusPro:', response.data);
      const { compraId } = response.data;
      
      // 2. Confirmar pago en backend ActiveStatusPro
      const confirmData = {
        orderID: details.id,
        paymentID: details.purchase_units[0].payments?.captures?.[0]?.id || details.id,
        paypalStatus: details.status,
        paypalDetails: details
      };
      console.log('Confirmando pago ActiveStatusPro con data:', confirmData);
      
      await axios.post(`https://dynappmos.com:8488/dynappmos/services/sendmail/activestatuspro/compra/${compraId}/confirmar`, confirmData);
      console.log('Pago ActiveStatusPro confirmado exitosamente');
      
      // Track successful purchase
      analytics.purchase(details.id, amount, [{ name: 'ActiveStatusPro', price: amount }]);
      
      onSuccess(details);
    } catch (error) {
      console.error('=== ERROR CONFIRMANDO PAGO ACTIVESTATUSPRO ===');
      console.error('Error completo:', error);
      if (axios.isAxiosError(error)) {
        console.error('Error response:', error.response?.data);
      }
      onError(error);
    }
  };

  const handleError = (error: any) => {
    console.error('PayPal ActiveStatusPro Error:', error);
    onError(error);
  };

  const initialOptions = {
    clientId: "AZ-U69Xu85NrpuokdK4Lr9i1746lT2bd5WtOd9cny4YdoMAWoCV_VNTeXZkBj9OIC-GRIFizeQzj1Qs3",
    currency: currency,
    intent: "capture" as const,
    components: "buttons",
    "data-page-type": "checkout",
    environment: "production" as const // Modo producción para pagos reales
  };

  return (
    <PayPalContainer>
      <PayPalScriptProvider 
        options={initialOptions}
      >
        <PayPalButtons
          disabled={disabled}
          style={{
            layout: 'vertical',
            color: 'gold',
            shape: 'rect',
            label: 'paypal',
            height: 50
          }}
          createOrder={createOrder}
          onApprove={onApprove}
          onError={handleError}
          onCancel={onCancel}
          forceReRender={[amount]}
        />
      </PayPalScriptProvider>
    </PayPalContainer>
  );
};

export default PayPalButtonActiveStatus;